<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('Price.FCLWeightLimitInformationDetails')"
    width="340px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    top="5vh"
    custom-class="details-view weight-limit-form"
  >
    <div class="main-content">
      <div style="margin-bottom: 10px">
        <el-button no="onSubmit" type="primary" @click="onSubmit">{{ $t('Pricing.Save') }}</el-button>
        <el-button no="onCancel" @click="onCancel">{{ $t('Pricing.Cancel') }}</el-button>
      </div>
      <div style="width: fit-content">
        <div style="display: flex">
          <div class="section form-column">
            <el-form
              :disabled="readonly"
              label-width="100px"
              label-position="left"
            >
              <el-form-item ref="pol" required :label="$t('Pricing.POL')">
                <cargo-advance-select
                  no="pol"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  :custom-label="(item)=>`[${item.code}]${item.englishName}`"
                  :filter-tag-names="['code','englishName']"
                  :show-custom-label-in-option="true"
                  :default-value="price.pol"
                  filterable
                  @parentCallBack="p=>{price.pol=p.value}"
                />
              </el-form-item>
              <el-form-item ref="pod" required :label="$t('Pricing.POD')">
                <cargo-advance-select
                  no="pod"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  :custom-label="(item)=>`[${item.code}]${item.englishName}`"
                  :filter-tag-names="['code','englishName']"
                  :show-custom-label-in-option="true"
                  :default-value="price.pod"
                  filterable
                  @parentCallBack="p=>{price.pod=p.value}"
                />
              </el-form-item>
              <el-form-item ref="via" :label="$t('Pricing.Via')">
                <cargo-advance-select
                  no="via"
                  :select-type="selectTypeNames.basic_data_Seaport"
                  :custom-label="(item)=>`[${item.code}]${item.englishName}`"
                  :filter-tag-names="['code','englishName']"
                  :show-custom-label-in-option="true"
                  :default-value="price.via"
                  filterable
                  @parentCallBack="p=>{price.via=p.value}"
                />
              </el-form-item>
              <el-form-item ref="carrier" required :label="$t('Pricing.Carrier')">
                <cargo-advance-select
                  no="carrier"
                  filterable
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{seaCmp:true}"
                  :custom-label="(item)=>`[${item.shortName}]${item.chineseName}`"
                  :show-custom-label-in-option="true"
                  :default-value="price.carrier"
                  @parentCallBack="p=>{price.carrier=p.cmpIdx}"
                />
              </el-form-item>
              <el-form-item ref="isFrequency" required :label="$t('Pricing.DepartureDay')">
                <el-input
                  no="isFrequency"
                  :disabled="true"
                  :value="isFrequency"
                />
              </el-form-item>
              <el-checkbox v-model="price.frequency1" no="frequency1" :label="1" style="margin-right: 12px;" />
              <el-checkbox v-model="price.frequency2" no="frequency2" :label="2" style="margin-right: 12px;" />
              <el-checkbox v-model="price.frequency3" no="frequency3" :label="3" style="margin-right: 12px;" />
              <el-checkbox v-model="price.frequency4" no="frequency4" :label="4" style="margin-right: 12px;" />
              <el-checkbox v-model="price.frequency5" no="frequency5" :label="5" style="margin-right: 12px;" />
              <el-checkbox v-model="price.frequency6" no="frequency6" :label="6" style="margin-right: 12px;" />
              <el-checkbox v-model="price.frequency7" no="frequency7" :label="7" style="margin-right: 12px;" />
              <el-form-item ref="eqType" required :label="$t('Pricing.EqType')">
                <cargo-advance-select
                  no="eqType"
                  :select-type="selectTypeNames.basic_data_EQType"
                  tag-name="code"
                  :clearable="false"
                  :default-value="price.eqType"
                  @parentCallBack="p=>{price.eqType=p.value}"
                />
              </el-form-item>
              <el-form-item ref="eqSize" required :label="$t('Pricing.EqSize')">
                <cargo-advance-select
                  no="eqSize"
                  :select-type="selectTypeNames.local_cache_EQSize"
                  tag-name="code"
                  :clearable="false"
                  :default-value="price.eqSize"
                  @parentCallBack="p=>{price.eqSize=p.value}"
                />
              </el-form-item>
              <el-form-item ref="currency" required :label="$t('Pricing.Currency')">
                <cargo-advance-select
                  no="currency"
                  :select-type="selectTypeNames.basic_data_Currency"
                  :clearable="false"
                  :default-value="price.currency"
                  @parentCallBack="p=>{price.currency=p.value}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.WeightRule')">
                <rate-grade
                  no="weightRule"
                  :grade-min="price.gradeMin"
                  :grade-max="price.gradeMax"
                  @onChangeMin="p=>{price.gradeMin=p}"
                  @onChangeMax="p=>{price.gradeMax=p}"
                />
              </el-form-item>
              <el-form-item :label="$t('Pricing.Amount')">
                <numeric-stepper
                  no="amount"
                  :show-tact="false"
                  :show-value="price.amount"
                  @onChangeValue="p=>{price.amount=p}"
                />
              </el-form-item>
              <el-form-item ref="beginDate" required :label="$t('Pricing.BeginDate')">
                <div style="display: flex">
                  <el-date-picker
                    v-model="price.beginDate"
                    no="beginDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    style="flex: 1;"
                    clearable
                  />
                </div>
              </el-form-item>
              <el-form-item ref="endDate" required :label="$t('Pricing.EndDate')">
                <div style="display: flex">
                  <el-date-picker
                    v-model="price.endDate"
                    no="endDate"
                    type="date"
                    value-format="yyyy-MM-dd"
                    style="flex: 1;"
                    clearable
                  />
                </div>
              </el-form-item>
              <el-form-item :label="$t('Pricing.Remarks')">
                <el-input
                  v-model="price.remarks"
                  no="remarks"
                  type="textarea"
                  :maxlength="255"
                />
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import CargoAgGrid from '@/components/Cargo/Common/cargoAgGrid'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import StrUtils from '@/utils/StrUtils'
import { save } from '@/api/price/priceWeightLimit'
import { getLoading } from '@/utils/utilBaseElement'
import NumericStepper from '@/views/cargo/v0/Price/components/numericStepper'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import RateGrade from '@/views/cargo/v0/Price/components/rateGrade'

export default {
  name: 'WeightLimitForm',
  components: { RateGrade, NumericStepper, CargoAgGrid, cargoAdvanceSelect },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    readonly: {
      type: Boolean,
      default: () => false
    },
    isNew: {
      type: Boolean,
      default: () => false
    },
    price: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      fullscreenLoading: null
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    },
    isFrequency() {
      return this.setFrequency('frequency')
    }
  },
  methods: {
    onSubmit() {
      if (this.verifyForm()) {
        return
      }
      if (this.verifySame('pol', 'pod')) {
        return
      }
      if (!StrUtils.isEmpty(this.price.via)) {
        if (this.verifySame('via', 'pol')) {
          return
        }
        if (this.verifySame('via', 'pod')) {
          return
        }
      }
      if (this.price.beginDate > this.price.endDate) {
        this.$message.warning(this.$t('Pricing.CompareValidate'))
        return
      }
      this.price.modifiedBy = this.$store.getters.userId
      this.price.dateModified = new Date()
      this.price.branchId = this.$store.getters.currentOfficeId
      this.save()
    },
    save() {
      this.fullscreenLoading = getLoading()
      let changeState = false
      if (!this.isNew && this.price.state === 1) {
        this.price.state = 0
        changeState = true
      }
      save(this.price).then((res) => {
        this.fullscreenLoading.close()
        if (res.data) {
          if (!changeState) {
            this.$message.success(this.$t('Pricing.SavedSucceed'))
          } else {
            this.$message.success(this.$t('Pricing.CurrentPriceEditSucceed'))
          }
          this.$emit('reload')
        } else {
          this.$message.success(this.$t('Message.SaveFailed'))
        }
        this.$emit('close')
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    verifyForm() {
      for (const ref in this.$refs) {
        if (this.$refs[ref].isRequired && this.verifyField(ref)) {
          const label = this.$refs[ref].label
          this.$message.warning(label + this.$t('Pricing.WrongInput'))
          return true
        }
      }
    },
    verifyField(field) {
      if (field === 'isFrequency') {
        return StrUtils.isEmpty(this.isFrequency)
      }
      if (typeof this.price[field] === 'number') {
        return this.price[field] === 0
      }
      return StrUtils.isEmpty(this.price[field])
    },
    onCancel() {
      this.$emit('close')
    },
    verifySame(field1, field2) {
      if (this.price[field1] === this.price[field2]) {
        const label1 = this.$refs[field1].label
        const label2 = this.$refs[field2].label
        const message = this.$t('Pricing.MustDifferent')
        this.$message.warning(message.replace('{0}', label1).replace('{1}', label2))
        return true
      }
      return false
    },
    setFrequency(targetField) {
      const FREQUENCYS = PriceUtils.FREQUENCYS
      const arr = []
      for (const field of FREQUENCYS) {
        if (this.price[targetField + field]) {
          arr.push(field)
        }
      }
      return arr.join('/')
    }
  }
}
</script>

<style lang="scss">
  @import "~@/styles/element-variables.scss";
  .weight-limit-form{
    .el-textarea__inner{
      min-height: 100px !important;
    }
    .form-operator{
      margin-left: 5px;
      cursor: pointer;
      font-size: 18px;
      .el-icon-circle-plus{
        color: $--color-success;
      }
      .el-icon-remove
      {
        color: $--color-danger;
      }
    }
  }
</style>
